/**
 * Why a run's transcript did not load. The trajectory and conversation
 * endpoints answer 404 only when no stored trace exists for the run
 * (`TraceNotFoundError`). Every other failure means trace storage could not
 * be read, and reading that as an aged-out run sends whoever debugs it after
 * the wrong cause. Pure module, so it tests without the API client.
 */
export type TranscriptLoadError = 'not-found' | 'unavailable'

export const TRANSCRIPT_LOAD_ERROR_MESSAGES: Record<TranscriptLoadError, string> = {
  'not-found':
    'No stored trace exists for this run. Trace capture may have been off, or the run may be older than the retention window.',
  unavailable:
    'Trace storage could not be read. Refresh to retry. If the error persists, the API logs say why.',
}

/**
 * `failed` covers a thrown request and a response other than the 200 body;
 * `status` is the thrown error's HTTP status, when it has one.
 */
export function transcriptLoadError(
  failed: boolean,
  status: number | undefined,
): TranscriptLoadError | null {
  if (!failed) return null
  return status === 404 ? 'not-found' : 'unavailable'
}
